import API from "@/common/API";
import { FormatMoney } from "@/common/helpers";
import { useEffect, useState } from "react";
import { Card } from "react-bootstrap"
import { useTranslation } from "react-i18next";

const OchoaDetails = ({ model }) => {
    const { t } = useTranslation("global");
    const [invoices, setInvoices] = useState([]);
    const [loading, setLoading] = useState(true);
    const [quotes, setQuotes] = useState([]);

    const bindData = async () => {
        try {
            setLoading(true);
            const request = await API.getAction(`placeDashboard/invoices?id=${model.id}`);
            if (request.status === 200) {
                setInvoices(request.data.response);
            }
            const quotesRequest = await API.getAction(`placeDashboard/quotes?id=${model.id}`);
            if (quotesRequest.status === 200) {
                setQuotes(quotesRequest.data.response);
            }
        } catch (ex) {
            console.error(ex);
        }
        finally {
            setLoading(false);
        }
    }

    useEffect(() => {
        bindData();
    }, [])
    return (
        <>
            {invoices.length > 0 && (
                <Card className="mb-4 shadow-sm">
                    <Card.Header className="py-2">
                        <h5 className="display-5 mt-4">{t("Invoices")}</h5>
                    </Card.Header>
                    <Card.Body className="p-0">
                        <table className="table mb-0">
                            <thead>
                                <tr>
                                    <th>{t("Date")}</th>
                                    <th>{t("Invoice Number")}</th>
                                    <th>{t("Amount")}</th>
                                </tr>
                            </thead>
                            <tbody>
                                {invoices.map((invoice) => (
                                    <tr key={invoice.id}>
                                        <td>{new Date(invoice.fecha).toLocaleDateString()}</td>
                                        <td>{invoice.factura}</td>
                                        <td>RD$ {FormatMoney(invoice.valor)}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </Card.Body>
                </Card>
            )}
            {quotes.length > 0 && (
                <Card className="mb-4 shadow-sm">
                    <Card.Header className="py-2">
                        <h5 className="display-5 mt-4">{t("Quotes")}</h5>
                    </Card.Header>
                    <Card.Body className="p-0">
                        <table className="table mb-0">
                            <thead>
                                <tr>
                                    <th>{t("Date")}</th>
                                    <th>{t("Quote Number")}</th>

                                    <th>{t("Amount")}</th>
                                </tr>
                            </thead>
                            <tbody>
                                {quotes.map((quote) => (
                                    <tr key={quote.id}>
                                        <td>{new Date(quote.fechaCotizacion).toLocaleDateString()}</td>
                                        <td>{quote.cotizacion}</td>

                                        <td>RD$ {FormatMoney(quote.montoCotizacion)}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </Card.Body>
                </Card>)}
        </>
    );
}
export default OchoaDetails;        
